import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["onClick", "onMouseenter"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ObserverComponent = _resolveComponent("ObserverComponent")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createBlock(_component_VDropdown, {
    id: _ctx.id,
    ref: `dropdownMenuRef_${_ctx.id}`,
    distance: _ctx.distance,
    skidding: _ctx.skidding,
    placement: _ctx.placement,
    triggers: _ctx.triggers,
    autoHide: _ctx.autoHide,
    class: _normalizeClass([_ctx.className, "dropdown-menu"]),
    popperClass: _ctx.popperClass,
    container: _ctx.container,
    shown: _ctx.shown,
    delay: _ctx.delay,
    disabled: _ctx.disabled,
    theme: "info-dropdown",
    onApplyShow: _ctx.onApplyShow,
    onApplyHide: _ctx.onApplyHide,
    onShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onShow'))),
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onHide')))
  }, {
    popper: _withCtx(() => [
      _renderSlot(_ctx.$slots, "before-list", { hideDropdown: _ctx.hideDropdown }),
      _renderSlot(_ctx.$slots, "list", { hideDropdown: _ctx.hideDropdown }, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["custom-scroll dropdown-menu__list", { 'dropdown-menu__empty-list': !_ctx.values.length }]),
          id: _ctx.listId
        }, [
          (_ctx.values.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    ref_for: true,
                    ref: `listOfElementRefs_${_ctx.id}`,
                    class: _normalizeClass([[
                { 'add-hover': _ctx.selectedElementIndex < 0 },
                { 'is-selected': index === _ctx.selectedElementIndex },
                { 'reset-padding': _ctx.resetPaddingForItem },
                value?.class
              ], "dropdown-menu__item dropdown-menu--keyboard-navigation__item"]),
                    onClick: ($event: any) => (_ctx.onSelect({ value, index })),
                    onMouseenter: ($event: any) => (_ctx.selectedElementIndexLocal = index),
                    onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _renderSlot(_ctx.$slots, "item", {
                      value: value,
                      index: index,
                      hideDropdown: _ctx.hideDropdown
                    })
                  ], 42, _hoisted_2))
                }), 128)),
                _createVNode(_component_ObserverComponent, {
                  class: "dropdown-menu__observer",
                  last: _ctx.isLast,
                  options: { threshold: 0.5 },
                  onIntersect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onScroll')))
                }, null, 8, ["last"])
              ], 64))
            : (_openBlock(), _createBlock(_component_BaseSubHeading, {
                key: 1,
                class: "dropdown-menu__empty",
                size: "large",
                weight: "400",
                color: "monochrome-06"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.noOptionsText), 1)
                ]),
                _: 1
              }))
        ], 10, _hoisted_1)
      ]),
      _renderSlot(_ctx.$slots, "after-list", { hideDropdown: _ctx.hideDropdown })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "label", { hideDropdown: _ctx.hideDropdown })
    ]),
    _: 3
  }, 8, ["id", "distance", "skidding", "placement", "triggers", "autoHide", "class", "popperClass", "container", "shown", "delay", "disabled", "onApplyShow", "onApplyHide"]))
}